const sectionCode = "SPRO2";
const chartCode = "C039x";

import { Procedures } from "modules/provider/shared/procedure-charts";

function T39Procedures() {
  return <Procedures chartCode={chartCode} sectionCode={sectionCode} />;
}

export { T39Procedures };
